// Company data
export const CompanyName = 'Mistress Maria';
export const CompanyPhoneNumber = '07733277698';
export const CompanyWhatsappNumber = '+447704187513';
export const CompanyEmailAddress = 'ms-maria@mail.com';
export const DirectorName = 'Mistress Maria';
export const LocationCity = 'Norfolk';
export const LocationCountry = 'United Kingdom';

// Address Constants
export const AddressLine1 = 'Private Discreet Location';
export const AddressLine2 = 'Norfolk Countryside';
export const AddressLine3 = '';
export const AddressLine4 = 'United Kingdom';
export const PostalCode = 'NR## ###'; // Optional: use partial or masked postcode for privacy

export const CompanyTagLine = 'Strict. Sensual. Supreme.';
export const MainTitle = 'Elite Dominatrix in Norfolk';
export const SubtitleMain = 'Submission is not given—it is earned.';
export const SubtitleSecondary = `How can ${CompanyName} command your desires?`;

export const KeywordsPages =
  'Mistress Maria, Norfolk Dominatrix, UK Femdom, BDSM sessions Norfolk, Female Domination, submissive training, discipline and control, fetish lifestyle, sissy training, financial domination, real time sessions, online domination, findom, sensual domme';

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 1;
export const CookiePolicyName = 'CookiePolicy';
export const CONSENT_KEY = 'UserConsent18Plus';

// Business URL
export const FULL_BUSINESS_URL = 'https://www.mistress-maria-abdl.com';
export const SHORT_BUSINESS_URL = 'mistress-maria-abdl.com';
export const DISPLAY_BUSINESS_URL = 'www.mistress-maria-abdl.com';

// Social Media URLs
export const AMAZON_WISHLIST_URL =
  'https://www.amazon.co.uk/hz/wishlist/ls/38D9T47XE6MGP?ref_=wl_share';
export const THRONE_URL = 'https://throne.com/mistress_treat';
export const LOVERFANS_URL = 'https://loverfans.com/Madames_Place';
export const FETLIFE_URL = 'https://fetlife.com/Mistress_Maria_x';
export const KO_FI_URL = 'https://ko-fi.com/nannym4u';
export const LOVERFANS_NANNYM_URL = 'https://loverfans.com/NannyM_X';
export const THRONE_NANNYM_URL = 'https://throne.com/nanny-m';
export const LOVERFANS_MADAMES_PLACE_URL =
  'https://loverfans.com/Madames_Place';
export const TELEGRAM_URL = '';
export const PAYPAL_URL = '';
export const CASH_APP_URL = '';
export const APPLE_PAY_EMAIL = '';
export const WISHLIST_URL = '';
export const VENMO_URL = '';
export const SCATBOOK_URL = '';
export const YOUPAY_URL = '';
export const ONLYFANS_URL = '';
export const LOYALFANS_URL = '';
export const FANSLY_URL = '';
export const SNAPCHAT_URL = '';
export const TIKTOK_URL = '';
export const TWITTER_URL = '';
export const FACEBOOK_URL = 'https://facebook.com/';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const LINKEDIN_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

export const ELITE_MISTRESS_UK = 'https://www.eliteukmistresses.co.uk'
export const DOMINA_SUPERIOR = 'https://www.dominasuperior.com/'
export const UK_MISTRESS_DIRECTORY = 'https://www.uk-mistress-directory.co.uk/'
export const UK_MISTRESS_ZONE = 'https://ukmistresszone.co.uk/'
export const WORLDWIDE_GUIDE = 'https://worldwidemistressguide.com/'
// Additional extracted URLs

// Maps
export const GoogleMapsEmbedUrl =
  'https://www.google.com/maps/embed?pb=YOUR-EMBEDDED-MAP-URL';

// Bot Data
export const BotName = 'Jerry';
